import React, { useEffect } from 'react';

// assets
import Link from '../../../../../../assets/customSVG/sequence/Link';
import Tick from '../../../../../../assets/customSVG/Tick';
import Download from '../../../../../../assets/customSVG/sequence/Download';

// helpers
import { downloadImageFromUrl } from 'helper/fileSaver';
import { copyText } from 'helper/text';
import { cn } from 'helper/cn';

// hooks
import useToggle from '../../../../../../hooks/useToggle';

// components
import Handler from '../../edge/Handler';

export default function QrTriggerPreview({
  previewType = 'default',
  node,
  color,
  isConnected,
  onEdgeMouseDown,
  checkIsEdgeConnected,
  allowToShowEdge = true,
  allowToEditFlow,
}) {
  const [isCopied, setIsCopied] = useToggle(false);

  useEffect(() => {
    if (isCopied) {
      const timeout = setTimeout(() => setIsCopied(false), 5000);

      return () => clearTimeout(timeout);
    }
  }, [isCopied]);

  const connection_point = {
    id: node?.data?.id,
    type: 'action',
  };

  return (
    <div className='relative w-full h-full px-2.5 py-5 bg-white rounded-xl'>
      <div className='relative w-full max-w-64 flex flex-col items-center justify-center gap-5 px-4 py-2.5 bg-[#F8F9FC] rounded-[10px]'>
        <img
          src={node?.data?.QR}
          alt='qr_code'
          className='w-full h-full rounded-2xl'
        />
        <div className='w-full h-9 flex items-center justify-between gap-2.5'>
          <button
            className='w-full h-full flex-1 flex items-center justify-center gap-1 text-xs weight-semibold text-[var(--font-600)] bg-[var(--BG-50)] rounded-md'
            onClick={() => {
              if (node?.data?.QR?.length > 0)
                downloadImageFromUrl(node?.data?.QR);
            }}>
            <Download
              width={17}
              height={17}
            />
            <span>Download</span>
          </button>
          <button
            className={cn(
              'w-full h-8 flex-1 flex items-center justify-center gap-1 text-xs weight-semibold text-[var(--font-600)] rounded-md transition-all ease-linear duration-150',
              isCopied ? 'bg-[var(--primary)]' : 'bg-[var(--BG-50)]'
            )}
            onClick={() => {
              if (!isCopied && node?.data?.url?.length > 0) {
                copyText(node?.data?.url);
                setIsCopied(true);
              }
            }}>
            {isCopied ? (
              <Tick
                width='12'
                height='10'
                strokeWidth='3'
                stroke='white'
              />
            ) : (
              <>
                <Link
                  width={14}
                  height={14}
                />
                <span>Copy URL</span>
              </>
            )}
          </button>
        </div>
        <div className='absolute top-1/2 -right-1.5'>
          <Handler
            type='start'
            start_node_id={node?.uniq_id}
            isConnected={isConnected}
            onEdgeMouseDown={({ position, payload }) => {
              if (onEdgeMouseDown) {
                if (!isConnected)
                  onEdgeMouseDown({
                    connection_point,
                    position: position,
                    payload,
                  });
              }
            }}
            color={color}
            allowToEditFlow={allowToEditFlow}
          />
        </div>
      </div>
    </div>
  );
}
